/* GoodlyLane · Patella Knee Strap — carregado SOMENTE pelo layout theme.knee.liquid */
(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Rolagem suave para âncoras internas ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-kp-scroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var target = href === '#MainContent' ? (qs('.kp-kits') || qs('.product__info-container') || qs(href)) : qs(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: href === '#MainContent' ? 'center' : 'start' });
  });

  /* ---------- Kits ligados ao seletor nativo do Dawn ---------- */
  function nativeInputs() {
    return qsa('.product__info-container variant-selects input[type="radio"]');
  }
  function checkedValue() {
    var checked = nativeInputs().filter(function (i) { return i.checked; })[0];
    if (checked) return checked.value;
    var sel = qs('.product__info-container variant-selects select');
    return sel ? sel.value : null;
  }
  function paintKits() {
    var val = checkedValue();
    if (val === null) return;
    qsa('[data-kp-kit]').forEach(function (k) {
      var on = k.getAttribute('data-value') === val;
      k.classList.toggle('is-on', on);
      k.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var kit = e.target.closest('[data-kp-kit]');
    if (!kit || kit.disabled) return;
    var val = kit.getAttribute('data-value');
    var input = nativeInputs().filter(function (i) { return i.value === val; })[0];
    if (input) {
      if (!input.checked) input.click();
    } else {
      var sel = qs('.product__info-container variant-selects select');
      if (sel) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    qsa('[data-kp-kit]').forEach(function (k) {
      var on = k === kit;
      k.classList.toggle('is-on', on);
      k.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    syncSticky();
  });
  document.addEventListener('keydown', function (e) {
    var kit = e.target.closest && e.target.closest('[data-kp-kit]');
    if (!kit || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
    var all = qsa('[data-kp-kit]:not([disabled])');
    var i = all.indexOf(kit) + (e.key === 'ArrowDown' ? 1 : -1);
    if (all[i]) { e.preventDefault(); all[i].focus(); all[i].click(); }
  });

  /* ---------- Barra fixa no celular ---------- */
  var bar = qs('[data-kp-sticky]');
  var btn = bar && qs('[data-kp-sticky-btn]', bar);
  var priceOut = bar && qs('[data-kp-sticky-price]', bar);
  var label = btn ? btn.textContent : '';

  function mainBtn() { return qs('.product product-form .product-form__submit') || qs('product-form .product-form__submit'); }

  function syncSticky() {
    if (!bar) return;
    var b = mainBtn();
    if (b) {
      var off = b.hasAttribute('disabled') || b.getAttribute('aria-disabled') === 'true';
      btn.disabled = off;
      var span = qs('span', b);
      btn.textContent = off && span ? span.textContent.trim() : label;
    }
    var kit = qs('[data-kp-kit].is-on');
    if (kit && priceOut) {
      priceOut.textContent = kit.getAttribute('data-title') + ' · ' + kit.getAttribute('data-price');
    } else if (priceOut) {
      var wrap = qs('.product [id^="price-"]');
      var p = wrap && (qs('.price--on-sale .price-item--sale', wrap) || qs('.price__regular .price-item--regular', wrap));
      if (p && p.textContent.trim()) priceOut.textContent = p.textContent.trim();
    }
  }

  if (bar && btn) {
    btn.addEventListener('click', function () {
      var b = mainBtn();
      if (b && !b.disabled) b.click();
    });
    if (mainBtn()) {
      bar.hidden = false;
      var ticking = false;
      var check = function () {
        ticking = false;
        var b = mainBtn();
        bar.classList.toggle('is-on', b ? b.getBoundingClientRect().bottom < 0 : false);
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
      }, { passive: true });
      window.addEventListener('resize', check);
      check();
    }
  }

  function refresh() { paintKits(); syncSticky(); }
  refresh();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(refresh, 60); });
  }
  var info = qs('.product__info-container');
  if (info && 'MutationObserver' in window) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(refresh, 30); })
      .observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
  }
})();
